



















import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'
import mixins from 'vue-typed-mixins'
import PasswordModel from '../registration/models/passwordModel'
import registrationMixin from './resetPasswordMixin'

export default mixins(registrationMixin, mobileTypeMixin).extend({
    data() {
        return {
            model: new PasswordModel()
        }
    },
    mounted() {
        this.init(this.model)
    },
    methods: {
        confirm() {
            this.validate(this.model)
        }
    }
})
